import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import { AlertService } from 'cdc-conte-ui-kit';
import { CsrfService } from '../services/csrf-service';
import { SpinnerService } from '../services/spinner-service';
import { shouldDeferCsrfError } from './csrf-interceptor';
import { shouldSuppressHttpErrorAlert } from './suppress-http-error-alert';

export const keycloakAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const loginUrl = `${environment.BASE_URL}/${environment.CONTEXT_AUTORIZZAZIONI_AUTH}/oauth2/authorization/keycloak`;
  const redirectParam = `?redirect_uri=${environment.APP_URL}/profili`;

  const fullUrl = loginUrl + redirectParam;
  const alertService = inject(AlertService);
  const csrfService = inject(CsrfService);
  const spinnerService = inject(SpinnerService);

  return next(req).pipe(
    tap(event => {
      //* DEBUG
      // console.log('auth interceptor log:', event);
    }),
    catchError((error: HttpErrorResponse) => {
      if (shouldDeferCsrfError(req, error)) {
        return throwError(() => error);
      }

      if (error) {
        console.error('Error Auth Interceptor:', error);
        if (shouldSuppressHttpErrorAlert(req, error)) {
          spinnerService.disableSpinner();
          return throwError(() => error);
        }

        const msg: { url: string | null, statusCode: number | string, errorMessage: string, customError?: string } = {
          url: error.url,
          statusCode: error.status,
          errorMessage: error.message,
          customError: error.error?.message ?? 'Si è verificato un errore',
        };
        alertService.showAlert.set(false);
        // bisogna mettere un timeout altrimenti l'alert non si chiude e non si riapre con il nuovo messaggio di errore (la showAlert è un signal, quindi se è già true non triggera il cambiamento dello stato e quindi non mostra l'alert)
        setTimeout(() => {
          alertService.type.set('danger');
          alertService.title.set('Errore Chiamata Http');
          alertService.message.set(msg.errorMessage + ' - ' + msg.url + ' - ' + msg.statusCode);
          alertService.showAlert.set(true);
          spinnerService.disableSpinner();
        }, 0);

        if (error.status === 401) {
          csrfService.clearToken();
          window.location.href = fullUrl;
        }
      }
      return throwError(() => error);
    })
  );
};
